// extracted by mini-css-extract-plugin
export default {"call-to-action":"Button_call-to-action__yETkr","inversed-call-to-action":"Button_inversed-call-to-action__nME1-","red":"Button_red__ndORu"};